import { render } from "./UserBar.vue?vue&type=template&id=d85243ce"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"

import "../../../assets/css/header-menu.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__